import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from './store';

import { QueryClient, QueryClientProvider, focusManager } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools'

const queryClient = new QueryClient();


const queryConfig = {
    defaultOptions: {
        queries: {
            //无效. not useful, will refetch after refocus.详见Dominic的推特：）
            refetchOnWindowFocus: false,
            // retry: false,
        },
    }
    /** * refetchOnWindowFocus 窗口得到焦点时从新获取数据 * staleTime 过多久从新获取服务端数据 * cacheTime 数据缓存时间 默认是 5 * 60 * 1000 5分钟 */

};
//执行本句后，重新focus不refetch。 
// focusManager.setFocused(false);

ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
        <QueryClientProvider client={queryClient} config={queryConfig}>
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            <App />
        </QueryClientProvider>
    </Provider>
    // </React.StrictMode>
    ,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
